import {getHelpSaUrl} from '@/api/gsc/utils';

export const routes = {
  home: '/home',
  tutorials: 'tutorials',
  ottopage: 'otto-page',
  ottopagePublic: 'otto-page-public',
  ottoPageV2: 'seo-automation',
  ottoPpcAdsGoogle: 'google-ads-automation/google-ads',
  ottoPageV2Public: 'seo-automation-public',
  login: 'login',
  logout: 'logout',
  reportBuilder: {
    history: 'report-builder',
    bulkExport: 'report-builder/full-report',
    detail: 'report-builder/detail',
    list: 'report-builder/projects-list',
  },
  // reportBuilderV2: {
  //   history: 'report-builder-v2',
  //   bulkExport: 'report-builder-v2/full-report',
  //   detail: 'report-builder-v2/detail',
  //   list: 'report-builder-v2/projects-list',
  // },
  keywordExplorer: {
    default: 'research/keyword-researcher-old',
    listing: 'research/keyword-researcher-old/list',
    detail: 'research/keyword-researcher-old/detail',
  },
  keywordExplorerNew: {
    default: 'research/keyword-researcher',
    details: 'research/keyword-researcher/new/',
  },
  competitorExplorer: {
    default: 'research/competitor-researcher',
    public: 'research/competitor-researcher-public',
    listing: 'research/competitor-researcher/list',
    detail: 'research/competitor-researcher/detail',
  },
  competitorResearcher: {
    default: 'site-explorer/list',
    defaultPublic: 'site-explorer/list-public',
    detail: 'site-explorer/detail',
    topicalDominance: 'site-explorer/topical-dominance',
    detailPublic: 'site-explorer/detail-public',
    pages: 'site-explorer/pages',
    pagesPublic: 'site-explorer/pages-public',
    keywords: 'site-explorer/keywords',
    keywordsPublic: 'site-explorer/keywords-public',
    subdomains: 'site-explorer/subdomains',
    subdomainsPublic: 'site-explorer/subdomains-public',
    backlinks: 'site-explorer/backlinks',
    backlinksPublic: 'site-explorer/backlinks-public',
    googlePage: 'site-explorer/google-page',
    googlePagePublic: 'site-explorer/google-page-public',
    positionChanges: 'site-explorer/position-changes',
    positionChangesPublic: 'site-explorer/position-changes-public',
    competitors: 'site-explorer/competitors',
    competitorsPublic: 'site-explorer/competitors-public',
    // for home v2
    siteHealth: 'site-audit/overview',
    siteAudit: 'site-audit/list',
    trackedKeywords: 'research/keyword-rank-tracker',
    AISEOStrategy: '/otto-page',
    facebookAds: '/site-explorer/facebook-ads',
    facebookAdsPublic: '/site-explorer/facebook-ads-public',
  },
  backlinkResearcher: '/research/backlink-researcher',
  backlinkResearcherPublic: '/research/backlink-researcher-public',
  backlinkProfileAnalysis: '/research/backlink-profile-analysis',
  backlinkGapAnalysis: '/research/backlink-gap-analysis',
  keywordGapAnalysis: '/research/keyword-gap-analysis',
  keywordRankTracker: '/research/keyword-rank-tracker',
  keywordRankTrackerPublic: '/research/keyword-rank-tracker-public',
  localSeo: '/research/local-seo',
  gbpProjectsV2: '/gbp-galactic/gbp-projects',
  gbpProjectOverview: '/gbp-galactic/overview',
  gbpTasks: '/gbp-galactic/my-tasks',
  gbpPosts: '/gbp-galactic/posts',
  gbpReviews: '/gbp-galactic/reviews',
  gbpQAs: '/gbp-galactic/q-a',
  localSeoHeatmaps: '/gbp-galactic/local-seo-heatmaps',
  localSeoHeatmapsDetails: '/gbp-galactic/local-seo-heatmaps/details',
  localSerpsV2: '/gbp-galactic/local-search-results',
  localSerps: '/research/local-search-results',
  localSeoProjectsList: '/research/seo-projects-list',
  gbpAutomations: '/research/gbp-automations/my-tasks',
  gbpAutomationsPosts: '/research/gbp-automations/posts',
  gbpAutomationsOptimization: '/research/gbp-automations/optimization',
  myTasks: '/research/gbp-automations/my-tasks',
  gbpAutomationsReviews: '/research/gbp-automations/reviews',
  gbpAutomationsQuestions: '/research/gbp-automations/questions-and-answers',
  aiGmbWriter: '/research/ai-gmb-writer',
  localCitations: '/research/local-citations',
  localCitationsV2: '/gbp-galactic/local-citations',
  localSeoPublic: '/research/local-seo-public',
  // secondary navbar routes
  internalPagesReport: '/site-audit-old/reports/internal-pages-report',
  indexabilityReport: '/site-audit-old/reports/indexability-report',
  linksReport: '/site-audit-old/reports/links-report',
  redirectsBrokenReport: '/site-audit-old/reports/redirects-broken-report',
  xmlSitemapsReport: '/site-audit-old/reports/xml-sitemaps-report',
  pageSpeedReport: '/site-audit-old/reports/page-speed-report',
  contentDuplicatesReport: '/site-audit-old/reports/content-duplicate-report',
  socialTagsReport: '/site-audit-old/reports/social-tags-report',
  externalPagesReport: '/site-audit-old/reports/external-pages-report',
  localizationReport: '/site-audit-old/reports/localization-report',

  gsc: 'gsc',
  overview: 'gsc/overview',
  topPages: 'gsc/top-pages',
  topPagesNew: 'gsc/pages',
  contentResearcher: '/research/content-researcher',
  topKeywords: 'gsc/top-keywords',
  keywords: 'gsc/keywords',
  backlinks: 'gsc/backlinks',
  competitorDiscovery: 'gsc/competitor-discovery',
  siteStructure: 'gsc/site-structure',
  siteAuditor: 'site-audit',
  semanticGrader: 'content/semantic-grader',
  landingPageOptimizer: 'content/seo-content-assistant',
  landingPageOptimizerPublic: 'content/seo-content-assistant-public',
  contentIdeas: 'content/metatags-generator',
  onPageAudit: 'content/onpage-audit',
  onPageAuditPublic: 'content/onpage-audit-public',
  contentPlanner: 'content/content-planner',
  onPageAuditDetails: 'content/onpage-audit/detail',
  onPageAuditDetailsPublic: 'content/onpage-audit/detail-public',
  semanticGraderPublic: 'content/semantic-grader-public',
  aiContentGenerator: 'content/ai-content-generator',
  aiContentGeneratorPublic: 'content/ai-content-generator-public',
  createTasks: 'content/tasks',
  focusTerms: 'focus-terms',
  topicalMaps: 'content/topical-maps',
  bulkDaChecker: 'bulk-da-checker',
  backlinkAnalyzer: 'backlink/backlink-analyzer',
  topicalRelevance: 'backlink/topical-relevance',
  anchorText: 'backlink/anchor-text',
  toxicBacklink: 'backlink/toxic-backlinks',
  backlinkVelocity: 'backlink/backlink-velocity',

  schema: 'schema',
  settings: 'settings',
  account: {
    default: 'account',
    resendConfirmationEmail: 'account/resend-confirmation-email',
    signup: 'account/signup',
    resetPassword: 'account/reset-password',
    team: 'account/team',
  },
  scheduleConsult: 'schedule-consult',
  orders: {
    default: 'orders',
    linkBuilding: 'orders/link-building',
  },
  orderBuilder: 'order-builder',
  checkout: 'checkout',
  subscription: 'subscription',
  planDowngrade: 'plan-downgrade',
  integration: 'integrations/oauth2',
  performance: {
    default: 'performance',
    desktop: 'performance/desktop',
    mobile: 'performance/mobile',
  },
  domainAnalyzer: 'analyze?website=',
  meta: {
    default: 'meta',
    title: 'meta/title',
    header: 'meta/header',
    description: 'meta/description',
  },
  pageExplorer: '/site-audit/page-explorer',
  pricing: 'pricing',
  billing: 'billing',
  appsEcoSystem: 'app-ecosystem',

  test: 'test',
  schemaForm: 'schema-form',
  startOnBoarding: 'onboarding',
  agencySettings: 'agency-settings',
  saIssuesPageOld: '/site-audit/issues-page-old',
  saIssuesPage: '/site-audit/issues-page',
  saIssuesPagePublic: '/site-audit/issues-page-public',
  saAlertsPage: '/site-audit/alerts-page',
  saAlertsPagePublic: '/site-audit/alerts-page-public',
  // haro: 'haro',
  digitalPr: 'digital-pr/pr-outreach',
  journalistDetails: 'digital-pr/journalist-details',
  mediaOutletsDetail: 'digital-pr/mediaOutlets',
  urlIndexer: 'url-indexer',
  urlIndexerOverview: 'url-indexer/overview',
};

export const publicPages = [
  '/login',
  '/register',
  '/register-b',
  '/register-c',
  '/register-d',
  '/register-f',
  '/verify-customer/[...code]',
  '/forgot-password',
  '/resend-verification',
  '/analyze',
  '/bulk-da-checker-public',
  '/research/keyword-rank-tracker-public',
  '/research/local-seo-public',
  '/research/local-seo-public/[...id]',
  '/research/local-seo-public/[...id]',
  '/research/keyword-researcher-public',
  '/research/keyword-researcher-public/[...keyword]',
  '/research/keyword-researcher-old-public/[...keyword]',
  '/research/keyword-magic-tool-public',
  '/research/keyword-magic-tool-public/[...keyword]',
  '/research/keyword-researcher-magic-public/[...keyword]',
  '/content/seo-content-assistant-public/[uuid]',
  '/content/onpage-audit/detail-public/[...auditId]',
  '/content/onpage-audit/public',
  '/content/onpage-audit-public',
  '/content/content-planner/public/[...id]',
  '/content/content-planner-public',
  '/content/semantic-grader-public/[...id]',
  '/content/content-planner/public',
  '/content/ai-content-generator-public',
  '/content/rewriting-tool-public',
  '/content/content-ideas/public',
  '/content/metatags-generator/public',
  '/order-builder',
  '/otto-page-public',
  '/otto-page-public/tasks',
  '/pricing',
  '/site-audit/overview-public',
  '/gsc/overview-public',
  '/gsc/additional-info-public',
  '/gsc/site-structure-public',
  '/site-audit/issues-page-public',
  '/site-audit/issues-page-old-public',
  '/site-audit/sitewide-data-public',
  '/site-audit/page-explorer-public',
  '/site-audit/page-explorer-public/[...id]',
  '/research/backlink-researcher-public',
  '/research/backlink-researcher-public/[...keyword]',
  '/research/backlink-researcher-public',
  '/research/competitor-researcher-public/[...keyword]',
  '/research/competitor-researcher-public',
  '/research/keyword-researcher-old/public',
  '/research/domain-analyzer-public',
  '/research/backlink-profile-analysis-public',
  '/research/backlink-profile-analysis-public/[...id]',
  '/test-da',
  '/go/url',
  '/site-audit/list-public',
  '/site-audit/alerts-page-public',
  '/site-explorer/detail-public/[...id]',
  '/site-explorer/detail-public',
  '/site-explorer/list-public',
  '/site-explorer/keywords-public/[...id]',
  '/site-explorer/keywords-public',
  '/site-explorer/competitors-public/[...id]',
  '/site-explorer/competitors-public',
  '/site-explorer/backlinks-public/[...id]',
  '/site-explorer/backlinks-public',
  '/site-explorer/pages-public/[...id]',
  '/site-explorer/pages-public',
  '/site-explorer/position-changes-public/[...id]',
  '/site-explorer/position-changes-public',
  '/site-explorer/subdomains-public/[...id]',
  '/site-explorer/subdomains-public',
  '/site-explorer/google-page-public/[...id]',
  '/site-explorer/google-page-public',
  '/report-builder/full-report-public',
  '/report-builder/full-report-public',
  '/gsc/overview-public',
  '/seo-automation/public',
  '/research/keyword-rank-tracker-public/[...id]',
  '/site-explorer/facebook-ads-public/[...id]',
  '/go/view-report-public',
  '/gsc/pages-public',
  '/gsc/keywords-public',
  '/research/local-citations-public',
  '/otel-test',
];

export const linkgraphDomain = process.env.LINKGRAPH_COM;


// we must make sure to put each chart into group
// this will help show multiple charts on single page after they are hidden
// we can hide only some charts, but will always show them all
export const chartGroups = {
  pages: {
    PAGES_PAGE_CHART: 'PAGES_PAGE_CHART',
  },
};

export const fileErrors = {
  'Error opening GoogleSheets file.': 'Please check your file is valid and public.',
  'File is empty.': 'File or first line is empty, please try again.',
};

export const orderTypes = {
  customer_plan: 'Subscription',
  premium_ai_quota_top_up: 'AI Premium Quota',
  ai_quota_top_up: 'AI Quota Top Up',
  order: 'Order',
  universal_quota_top_up: 'Top Up',
  addon: 'Addon',
};

export const countryCodeToLocationDict = {
  'AF': 'Afghanistan',
  'AL': 'Albania',
  'DZ': 'Algeria',
  'AS': 'American Samoa',
  'AD': 'Andorra',
  'AO': 'Angola',
  'AI': 'Anguilla',
  'AQ': 'Antarctica',
  'AG': 'Antigua and Barbuda',
  'AR': 'Argentina',
  'AM': 'Armenia',
  'AW': 'Aruba',
  'AU': 'Australia',
  'AT': 'Austria',
  'AZ': 'Azerbaijan',
  'BS': 'Bahamas',
  'BH': 'Bahrain',
  'BD': 'Bangladesh',
  'BB': 'Barbados',
  'BY': 'Belarus',
  'BE': 'Belgium',
  'BZ': 'Belize',
  'BJ': 'Benin',
  'BM': 'Bermuda',
  'BT': 'Bhutan',
  'BO': 'Bolivia',
  'BQ': 'Bonaire, Sint Eustatius and Saba',
  'BA': 'Bosnia and Herzegovina',
  'BW': 'Botswana',
  'BV': 'Bouvet Island',
  'BR': 'Brazil',
  'IO': 'British Indian Ocean Territory',
  'BN': 'Brunei Darussalam',
  'BG': 'Bulgaria',
  'BF': 'Burkina Faso',
  'BI': 'Burundi',
  'KH': 'Cambodia',
  'CM': 'Cameroon',
  'CA': 'Canada',
  'CV': 'Cape Verde',
  'KY': 'Cayman Islands',
  'CF': 'Central African Republic',
  'TD': 'Chad',
  'CL': 'Chile',
  'CN': 'China',
  'CX': 'Christmas Island',
  'CC': 'Cocos (Keeling) Islands',
  'CO': 'Colombia',
  'KM': 'Comoros',
  'CG': 'Congo',
  'CD': 'Congo, Democratic Republic',
  'CK': 'Cook Islands',
  'CR': 'Costa Rica',
  'CI': "Cote d'Ivoire",
  'HR': 'Croatia',
  'CU': 'Cuba',
  'CW': 'CuraÃ§ao',
  'CY': 'Cyprus',
  'CZ': 'Czech Republic',
  'DK': 'Denmark',
  'DJ': 'Djibouti',
  'DM': 'Dominica',
  'DO': 'Dominican Republic',
  'TL': 'East Timor',
  'EC': 'Ecuador',
  'EG': 'Egypt',
  'SV': 'El Salvador',
  'GQ': 'Equatorial Guinea',
  'ER': 'Eritrea',
  'EE': 'Estonia',
  'ET': 'Ethiopia',
  'FK': 'Falkland Islands (Islas Malvinas)',
  'FO': 'Faroe Islands',
  'FJ': 'Fiji',
  'FI': 'Finland',
  'FR': 'France',
  'GF': 'French Guiana',
  'PF': 'French Polynesia',
  'TF': 'French Southern Territories',
  'GA': 'Gabon',
  'GM': 'Gambia',
  'GE': 'Georgia',
  'DE': 'Germany',
  'GH': 'Ghana',
  'GI': 'Gibraltar',
  'GR': 'Greece',
  'GL': 'Greenland',
  'GD': 'Grenada',
  'GP': 'Guadeloupe',
  'GU': 'Guam',
  'GT': 'Guatemala',
  'GG': 'Guernsey',
  'GN': 'Guinea',
  'GW': 'Guinea-Bissau',
  'GY': 'Guyana',
  'HT': 'Haiti',
  'HM': 'Heard and McDonald Islands',
  'HN': 'Honduras',
  'HK': 'Hong Kong',
  'HU': 'Hungary',
  'IS': 'Iceland',
  'IN': 'India',
  'ID': 'Indonesia',
  'IR': 'Iran',
  'IQ': 'Iraq',
  'IE': 'Ireland',
  'IL': 'Israel',
  'IT': 'Italy',
  'JM': 'Jamaica',
  'JP': 'Japan',
  'JE': 'Jersey',
  'JO': 'Jordan',
  'KZ': 'Kazakhstan',
  'KE': 'Kenya',
  'KI': 'Kiribati',
  'KW': 'Kuwait',
  'KG': 'Kyrgyzstan',
  'LA': "Lao People's Democratic Republic",
  'LV': 'Latvia',
  'LB': 'Lebanon',
  'LS': 'Lesotho',
  'LR': 'Liberia',
  'LY': 'Libya',
  'LI': 'Liechtenstein',
  'LT': 'Lithuania',
  'LU': 'Luxembourg',
  'MO': 'Macau',
  'MK': 'Macedonia',
  'MG': 'Madagascar',
  'MW': 'Malawi',
  'MY': 'Malaysia',
  'MV': 'Maldives',
  'ML': 'Mali',
  'MT': 'Malta',
  'MH': 'Marshall Islands',
  'MQ': 'Martinique',
  'MR': 'Mauritania',
  'MU': 'Mauritius',
  'YT': 'Mayotte',
  'MX': 'Mexico',
  'FM': 'Micronesia',
  'MD': 'Moldova',
  'MC': 'Monaco',
  'MN': 'Mongolia',
  'ME': 'Montenegro',
  'MS': 'Montserrat',
  'MA': 'Morocco',
  'MZ': 'Mozambique',
  'MM': 'Myanmar',
  'NA': 'Namibia',
  'NR': 'Nauru',
  'NP': 'Nepal',
  'NL': 'Netherlands',
  'AN': 'Netherlands Antilles',
  'NC': 'New Caledonia',
  'NZ': 'New Zealand',
  'NI': 'Nicaragua',
  'NE': 'Niger',
  'NG': 'Nigeria',
  'NU': 'Niue',
  'NF': 'Norfolk Island',
  'KP': 'North Korea',
  'MP': 'Northern Mariana Islands',
  'NO': 'Norway',
  'OM': 'Oman',
  'PK': 'Pakistan',
  'PW': 'Palau',
  'PS': 'Palestinian Territory',
  'PA': 'Panama',
  'PG': 'Papua New Guinea',
  'PY': 'Paraguay',
  'PE': 'Peru',
  'PH': 'Philippines',
  'PN': 'Pitcairn',
  'PL': 'Poland',
  'PT': 'Portugal',
  'PR': 'Puerto Rico',
  'QA': 'Qatar',
  'RE': 'Reunion',
  'RO': 'Romania',
  'RU': 'Russia',
  'RW': 'Rwanda',
  'KN': 'Saint Kitts and Nevis',
  'LC': 'Saint Lucia',
  'VC': 'Saint Vincent and the Grenadines',
  'WS': 'Samoa',
  'SM': 'San Marino',
  'ST': 'Sao Tome and Principe',
  'SA': 'Saudi Arabia',
  'SN': 'Senegal',
  'RS': 'Serbia',
  'SC': 'Seychelles',
  'SL': 'Sierra Leone',
  'SG': 'Singapore',
  'SX': 'Sint Maarten (Dutch part)',
  'SK': 'Slovakia',
  'SI': 'Slovenia',
  'SB': 'Solomon Islands',
  'SO': 'Somalia',
  'ZA': 'South Africa',
  'GS': 'South Georgia and The South Sandwich Islands',
  'KR': 'Korea Republic',
  'ES': 'Spain',
  'LK': 'Sri Lanka',
  'SH': 'St. Helena',
  'PM': 'St. Pierre and Miquelon',
  'SD': 'Sudan',
  'SR': 'Suriname',
  'SJ': 'Svalbard and Jan Mayen Islands',
  'SZ': 'Swaziland',
  'SE': 'Sweden',
  'CH': 'Switzerland',
  'SY': 'Syrian Arab Republic',
  'TW': 'Taiwan',
  'TJ': 'Tajikistan',
  'TZ': 'Tanzania',
  'TH': 'Thailand',
  'TG': 'Togo',
  'TK': 'Tokelau',
  'TO': 'Tonga',
  'TT': 'Trinidad and Tobago',
  'TN': 'Tunisia',
  'TR': 'Turkey',
  'TM': 'Turkmenistan',
  'TC': 'Turks and Caicos Islands',
  'TV': 'Tuvalu',
  'UG': 'Uganda',
  'UA': 'Ukraine',
  'AE': 'United Arab Emirates',
  'GB': 'United Kingdom',
  'US': 'United States',
  'UM': 'United States Minor Outlying Islands',
  'UY': 'Uruguay',
  'UZ': 'Uzbekistan',
  'VU': 'Vanuatu',
  'VA': 'Vatican',
  'VE': 'Venezuela',
  'VN': 'Vietnam',
  'VG': 'Virgin Islands (British)',
  'VI': 'Virgin Islands (U.S.)',
  'WF': 'Wallis and Futuna Islands',
  'EH': 'Western Sahara',
  'YE': 'Yemen',
  'ZM': 'Zambia',
  'ZW': 'Zimbabwe',
};

export const dateRangeDict = {
  oneMonth: '1 month',
  threeMonth: '3 Months',
  sixMonth: '6 Months',
  oneYear: '1 Year',
};

export const accessPages = {
  enableHomepage: {
    label: 'Home',
    route: '/home',
    subSection: 'tools',
  },
  enableSiteExplorer: {
    label: 'Site Explorer',
    route: '/site-explorer/list',
    subSection: 'tools',
  },
  enableSiteAudit: {
    label: 'Site Audit',
    route: '/site-audit/list',
    subSection: 'tools',
  },
  enableGscPerformance: {
    label: 'GSC Performance',
    route: '/gsc/sites-list',
    subSection: 'tools',
  },
  enableLocalSeo: {
    label: 'Local SEO',
    route: '/research/seo-projects-list',
    subSection: 'tools',
  },
  enableLocalSeoV2: {
    label: 'GBP Projects',
    route: '/gbp-galactic/gbp-projects',
    subSection: 'tools',
  },
  enableOtto: {
    label: 'OTTO V2',
    route: '/seo-automation',
    subSection: 'tools',
  },
  enableReportBuilder: {
    label: 'Report Builder',
    route: '/report-builder/projects-list',
    subSection: 'tools',
  },
  enableDigitalPr: {
    label: 'Digital PR',
    route: '/haro',
    subSection: 'tools',
  },
  enableBulkDaChecker: {
    label: 'Bulk DA Checker',
    route: '/bulk-da-checker',
    subSection: 'tools',
  },
  enableUrlIndexer: {
    label: 'URL Indexer',
    route: '/url-indexer',
    subSection: 'tools',
  },
  enableSchemaCreator: {
    label: 'Schema Creator',
    route: '/schema',
    subSection: 'tools',
  },
  enableBacklinkTools: {
    label: 'Backlinks',
    route: '/research/backlink-researcher',
    subSection: 'tools',
  },
  enableBulkUrlAnalyzer: {
    label: 'Bulk URL Analyzer',
    route: '/bulk-url-analyzer',
    subSection: 'tools',
  },
  enableSeoContentAssistant: {
    label: 'Content Genius',
    route: '/content/seo-content-assistant',
    subSection: 'content',
  },
  enableOnpageAudit: {
    label: 'Onpage Audit',
    route: '/content/onpage-audit',
    subSection: 'content',
  },
  enableMetaMapCreator: {
    label: 'CA Topical Maps',
    route: '/content/topical-maps',
    subSection: 'content',
  },
  enableContentPlanner: {
    label: 'Content Planner',
    route: '/content/content-planner',
    subSection: 'content',
  },
  enableAiContentTemplates: {
    label: 'AI Content Templates',
    route: '/content/ai-content-generator',
    subSection: 'content',
  },
  enableContentRewriting: {
    label: 'Content Rewriting',
    route: 'content/rewriting-tool',
    subSection: 'content',
  },
  enableKeywordResearch: {
    label: 'Keyword Research',
    route: '/research/keyword-researcher',
    subSection: 'keyword',
  },
  enableKeywordMagicTool: {
    label: 'Keyword Magic Tool',
    route: '/research/keyword-magic-tool',
    subSection: 'keyword',
  },
  enableKeywordRankTracker: {
    label: 'Keyword Rank Tracker',
    route: '/research/keyword-rank-tracker',
    subSection: 'keyword',
  },
  enableKeywordGap: {
    label: 'Keyword Gap',
    route: '/research/keyword-gap-analysis',
    subSection: 'keyword',
  },
  enableOrderBuilder: {
    label: 'Order Builder',
    route: '/order-builder',
    subSection: 'setting',
  },
  enableMyOrders: {
    label: 'My Orders',
    route: '/orders',
    subSection: 'setting',
  },
  enableBilling: {
    label: 'Billing',
    route: '/billing',
    subSection: 'setting',
  },
  enablePricing: {
    label: 'Pricing',
    route: '/pricing-agency',
    subSection: 'setting',
  },
  enableSettings: {
    label: 'Agency settings',
    route: '/agency-settings',
    subSection: 'setting',
  },
};

export const pagesFlags = {
  contentFlags: [
    'enableSeoContentAssistant',
    'enableOnpageAudit',
    'enableMetaMapCreator',
    'enableContentPlanner',
    'enableMetaGenerator',
    'enableAiContentTemplates',
    'enableContentRewriting',
  ],
  siteExplorerFlags: [
    'enableSiteExplorer',
    'enableSiteExplorerOverview',
    'enableSiteExplorerKeywords',
    'enableSiteExplorerPages',
    'enableSiteExplorerSubdomains',
    'enableSiteExplorerGoogleAds',
    'enableSiteExplorerPositionChanges',
    'enableSiteExplorerBacklinks',
    'enableSiteExplorerCompetitors',
  ],
  keywordsFlags: [
    'enableKeywordResearch',
    'enableKeywordMagicTool',
    'enableKeywordRankTracker',
    'enableKeywordGap',
  ],
  siteAuditFlags: [
    'enableSiteAudit',
    'enableSiteAuditOverview',
    'enableSiteAuditPageExplorer',
    'enableSiteAuditDomainLevel',
    'enableSiteAuditIssues',
    'enableSiteAuditPagePruning',
    'enableSiteAuditSiteVisualization',
    'enableSiteAuditEmailAlerts',
    'enableSiteAuditLiveAlertsMonitoring',
  ],
  gscPerformanceFlags: [
    'enableGscPerformance',
    'enableGscPerformanceOverview',
    'enableGscPerformancePages',
    'enableGscPerformanceKeywords',
    'enableGscPerformanceBacklinks',
    'enableGscPerformanceSiteStructure',
    'enableGscPerformanceCompetitorDiscovery',
    'enableGscPerformanceSiteEvents',
    'enableGscPerformanceReports',
    'enableGscPerformanceAdditionalInfo',
  ],
  digitalPRFlags: [
    'enableDigitalPr',
    'enableDigitalPrOutreach',
    'enableDigitalPrCampaigns',
    'enableDigitalPrInbox',
    'enableDigitalPrTemplates',
    'enableDigitalPrDistribution',
  ],
  reportBuilderFlags: [
    'enableReportBuilder',
    'enableReportBuilderFullReport',
    'enableReportBuilderIndividualReports',
  ],
  backlinksFlags: [
    'enableBacklinkTools',
    'enableBacklinkTools',
    'enableBacklinkToolsBacklinks',
    'enableBacklinkToolsLinkGapAnalysis',
    'enableBacklinkToolsCompareBacklinks',
    'enableBacklinkToolsTopicalRelevance',
    'enableBacklinkToolsBacklinkVelocity',
  ],
  localSEOFlags: [
    'enableLocalSeo',
    'enableLocalSeoGBPProjects',
    'enableLocalSeoMyBusinesses',
    'enableLocalSeoLocalSEOHeatmap',
    'enableLocalSeoLocalListings',
    'enableLocalSeoLocalCitations',
    'enableLocalSeoGBPAutomations',
    'enableLocalSeoLocalSERPs',
    'enableLocalSeoAIGBPWriter',
  ],
  enableLocalSeoV2: [
    'enableLocalSeoV2',
    'enableLocalSeoV2GbpProjects',
    'enableLocalSeoV2Overview',
  ],
};

export const WLchildrenPagesMapping = {
  '/home': 'enableHomepage',
  '/content/seo-content-assistant': 'enableSeoContentAssistant',
  '/content/onpage-audit': 'enableOnpageAudit',
  '/content/topical-maps': 'enableMetaMapCreator',
  '/content/content-planner': 'enableContentPlanner',
  '/content/metatags-generator': 'enableMetaGenerator',
  '/content/ai-content-generator': 'enableAiContentTemplates',
  '/content/rewriting-tool': 'enableContentRewriting',
  '/site-explorer/list': 'enableSiteExplorer',
  '/site-explorer/detail': 'enableSiteExplorer',
  '/site-explorer/keywords': 'enableSiteExplorer',
  '/site-explorer/pages': 'enableSiteExplorer',
  '/site-explorer/subdomains': 'enableSiteExplorer',
  '/site-explorer/google-page': 'enableSiteExplorer',
  '/site-explorer/facebook-ads': 'enableSiteExplorer',
  '/site-explorer/position-changes': 'enableSiteExplorer',
  '/site-explorer/backlinks': 'enableSiteExplorer',
  '/site-explorer/competitors': 'enableSiteExplorer',
  '/research/keyword-researcher': 'enableKeywordResearch',
  '/research/keyword-magic-tool': 'enableKeywordMagicTool',
  '/research/keyword-rank-tracker': 'enableKeywordRankTracker',
  '/research/keyword-gap-analysis': 'enableKeywordGap',
  '/site-audit/list': 'enableSiteAudit',
  '/site-audit/overview': 'enableSiteAudit',
  '/site-audit/page-explorer': 'enableSiteAudit',
  '/site-audit/sitewide-data': 'enableSiteAudit',
  '/site-audit/issues-page': 'enableSiteAudit',
  '/site-audit/pruning-page': 'enableSiteAudit',
  '/site-audit/site-visualization': 'enableSiteAudit',
  '/site-audit/email-alerts': 'enableSiteAudit',
  '/site-audit/alerts-page': 'enableSiteAudit',
  '/gsc/sites-list': 'enableGscPerformance',
  '/gsc/overview': 'enableGscPerformance',
  '/gsc/pages': 'enableGscPerformance',
  '/gsc/keywords': 'enableGscPerformance',
  '/gsc/backlinks': 'enableGscPerformance',
  '/gsc/site-structure': 'enableGscPerformance',
  '/gsc/competitor-discovery': 'enableGscPerformance',
  '/gsc/site-events': 'enableGscPerformance',
  '/gsc/reports': 'enableGscPerformance',
  '/gsc/additional-info': 'enableGscPerformance',
  '/digital-pr/pr-outreach': 'enableDigitalPr',
  '/digital-pr/journalist-details': 'enableDigitalPr',
  '/digital-pr/mediaOutlets': 'enableDigitalPr',
  '/outreach/campaigns': 'enableDigitalPr',
  '/outreach/inbox': 'enableDigitalPr',
  '/outreach/sent': 'enableDigitalPr',
  '/outreach/templates': 'enableDigitalPr',
  '/outreach/press-release': 'enableDigitalPr',
  '/report-builder': 'enableReportBuilder',
  '/report-builder/projects-list': 'enableReportBuilder',
  '/report-builder/full-report': 'enableReportBuilder',
  '/report-builder/detail': 'enableReportBuilder',
  '/bulk-da-checker': 'enableBulkDaChecker',
  '/url-indexer': 'enableUrlIndexer',
  '/schema': 'enableSchemaCreator',
  '/research/backlink-researcher': 'enableBacklinkTools',
  '/backlink/backlink-analyzer': 'enableBacklinkTools',
  '/research/backlink-gap-analysis': 'enableBacklinkTools',
  '/research/backlink-profile-analysis': 'enableBacklinkTools',
  '/backlink/topical-relevance': 'enableBacklinkTools',
  '/backlink/backlink-velocity': 'enableBacklinkTools',
  '/bulk-url-analyzer': 'enableBulkUrlAnalyzer',
  '/otto-page': 'enableOtto',
  '/research/local-seo': 'enableLocalSeo',
  '/research/seo-projects-list': 'enableLocalSeo',
  '/research/local-citations': 'enableLocalSeo',
  '/local-search-results': 'enableLocalSeo',
  '/research/ai-gmb-writer': 'enableLocalSeo',
  '/seo-automation': 'enableOtto',
  '/orders': 'enableMyOrders',
  '/billing': 'enableBilling',
  '/agency-settings': 'enableSettings',
  '/order-builder': 'enableOrderBuilder',
  '/pricing': 'enablePricing',
  '/gbp-galactic/gbp-projects': 'enableLocalSeoV2',
  '/gbp-galactic/overview': 'enableLocalSeoV2',
};

export const checkWLChildrenPagesStatus = (routeWl, WLchildrenPages) => {
  const mappedKey = WLchildrenPagesMapping[routeWl];
  return mappedKey ? Boolean(WLchildrenPages[mappedKey]) : true;
};

export const crawlerMapping = {
  'bing': {
    label: 'Bing',
    color: '#2D6CCA',
    icon: 'https://img.icons8.com/fluency/48/bing--v1.png',
  },
  'openai_bot': {
    label: 'OpenAI bot',
    color: '#F1AA3E',
    icon: 'https://img.icons8.com/fluency/48/chatgpt--v2.png',
  },
  'google': {
    label: 'Google',
    color: '#7F4EAD',
    icon: 'https://img.icons8.com/?size=100&id=17949&format=png&color=000000',
  },
  'google_mobile': {
    label: 'Google-Mobile',
    color: '#1FAC47',
    icon: 'https://img.icons8.com/?size=100&id=17949&format=png&color=000000',
  },
};

export const botChartMapping = {
  byDevices: {
    label: 'By device (screen size)',
    colors: ['rgba(127, 78, 173, 1)', 'rgba(241, 170, 62, 1)'],
  },
  crawlFrequency: {
    label: 'Crawl frequency',
  },
  crawlPurpose: {
    label: 'Crawl purpose',
    colors: ['rgba(45, 108, 202, 1)', 'rgba(31, 172, 71, 1)'],
  },
  siteIndexation: {
    label: 'Site indexation %',
    colors: ['rgba(31, 172, 71, 1)', 'rgba(115, 131, 131, 1)'],
  },
};

export const legendNamesMapping = {
  'lessThan1S': 'Less than one',
  'oneTo2S': 'One to two',
  'twoTo3S': 'Two to three',
  'threeTo4S': 'Three to four',
  'moreThan4': 'More than four',
};

export const schemaMarkupOrganizationTypes = [
  {'key': 'Airline', 'value': 'Airline'},
  {'key': 'AnimalShelter', 'value': 'Animal Shelter'},
  {'key': 'ArchiveOrganization', 'value': 'Archive Organization'},
  {'key': 'AutomotiveBusiness', 'value': 'Automotive Business'},
  {'key': 'ChildCare', 'value': 'Child Care'},
  {'key': 'CollegeOrUniversity', 'value': 'College Or University'},
  {'key': 'Consortium', 'value': 'Consortium'},
  {'key': 'Corporation', 'value': 'Corporation'},
  {'key': 'DanceGroup', 'value': 'Dance Group'},
  {'key': 'Dentist', 'value': 'Dentist'},
  {'key': 'DiagnosticLab', 'value': 'Diagnostic Lab'},
  {'key': 'DryCleaningOrLaundry', 'value': 'Dry Cleaning Or Laundry'},
  {'key': 'EducationalOrganization', 'value': 'Educational Organization'},
  {'key': 'ElementarySchool', 'value': 'Elementary School'},
  {'key': 'EntertainmentBusiness', 'value': 'Entertainment Business'},
  {'key': 'FinancialService', 'value': 'Financial Service'},
  {'key': 'FoodEstablishment', 'value': 'Food Establishment'},
  {'key': 'FundingScheme', 'value': 'Funding Scheme'},
  {'key': 'GovernmentOffice', 'value': 'Government Office'},
  {'key': 'GovernmentOrganization', 'value': 'Government Organization'},
  {'key': 'HealthAndBeautyBusiness', 'value': 'Health And Beauty Business'},
  {'key': 'HighSchool', 'value': 'High School'},
  {'key': 'HomeAndConstructionBusiness', 'value': 'Home And Construction Business'},
  {'key': 'Hospital', 'value': 'Hospital'},
  {'key': 'InternetCafe', 'value': 'Internet Cafe'},
  {'key': 'LegalService', 'value': 'Legal Service'},
  {'key': 'Library', 'value': 'Library'},
  {'key': 'LibrarySystem', 'value': 'Library System'},
  {'key': 'LocalBusiness', 'value': 'Local Business'},
  {'key': 'LodgingBusiness', 'value': 'Lodging Business'},
  {'key': 'MedicalBusiness', 'value': 'Medical Business'},
  {'key': 'MedicalClinic', 'value': 'Medical Clinic'},
  {'key': 'MedicalOrganization', 'value': 'Medical Organization'},
  {'key': 'MiddleSchool', 'value': 'Middle School'},
  {'key': 'MusicGroup', 'value': 'Music Group'},
  {'key': 'NGO', 'value': 'NGO'},
  {'key': 'Organization', 'value': 'Organization'},
  {'key': 'NewsMediaOrganization', 'value': 'News Media Organization'},
  {'key': 'PerformingGroup', 'value': 'Performing Group'},
  {'key': 'Pharmacy', 'value': 'Pharmacy'},
  {'key': 'Physician', 'value': 'Physician'},
  {'key': 'Preschool', 'value': 'Preschool'},
  {'key': 'ProfessionalService', 'value': 'Professional Service'},
  {'key': 'Project', 'value': 'Project'},
  {'key': 'RadioStation', 'value': 'Radio Station'},
  {'key': 'RealEstateAgent', 'value': 'Real Estate Agent'},
  {'key': 'RecyclingCenter', 'value': 'Recycling Center'},
  {'key': 'ResearchOrganization', 'value': 'Research Organization'},
  {'key': 'School', 'value': 'School'},
  {'key': 'SelfStorage', 'value': 'Self Storage'},
  {'key': 'ShoppingCenter', 'value': 'Shopping Center'},
  {'key': 'SportsActivityLocation', 'value': 'Sports Activity Location'},
  {'key': 'SportsOrganization', 'value': 'Sports Organization'},
  {'key': 'SportsTeam', 'value': 'Sports Team'},
  {'key': 'Store', 'value': 'Store'},
  {'key': 'TelevisionStation', 'value': 'Television Station'},
  {'key': 'TheaterGroup', 'value': 'Theater Group'},
  {'key': 'TouristInformationCenter', 'value': 'Tourist Information Center'},
  {'key': 'TravelAgency', 'value': 'Travel Agency'},
  {'key': 'VeterinaryCare', 'value': 'Veterinary Care'},
  {'key': 'WorkersUnion', 'value': 'Workers Union'},
];

export const CrawlMonitoringKnowledgeBase = {
  'data': `${getHelpSaUrl()}/en/articles/10118591-site-audit-knowledge-base#h_5ccd44decb:~:text=search%20engine%20rankings.-,Crawl%20Monitoring,-%5BBeta%5D`,
  'noData': `${getHelpSaUrl()}/en/articles/10118591-site-audit-knowledge-base#h_5ccd44decb:~:text=Why%20is%20the%20crawl%20monitoring%20of%20my%20site%20audit%20empty%3F`,
};

export const CMS_LINKS_MAPPING = {
  'Google Tag Manager': 'https://tagmanager.google.com/',
  'WordPress': 'https://wordpress.org/plugins/code-snippets/',
  'Shopify': 'https://admin.shopify.com/themes/current/editor',
  'Webflow': 'https://webflow.com/dashboard',
  'Squarespace': 'https://account.squarespace.com/',
  'Wix': 'https://www.wix.com/account/sites',
  'ClickFunnels': 'https://app.clickfunnels.com/sites',
  'Custom Installation': '',
  'OTTO Pixel': '',
};

export const INSTALLATION_GUIDE_PLATFORMS = [
  {name: 'Google Tag Manager'},
  {name: 'WordPress'},
  {name: 'Shopify'},
  {name: 'Webflow'},
  {name: 'Squarespace'},
  {name: 'ClickFunnels'},
  {name: 'Wix'},
  {name: 'GHL'},
  {name: 'Custom Installation'},
];
export const DEFAULT_LOCATIONS = [
  {
    countryCode: 'US',
    location: 'United States',
    locationId: 2840,
  },
  {
    countryCode: 'CA',
    location: 'Canada',
    locationId: 2124,
  },
  {
    countryCode: 'AU',
    location: 'Australia',
    locationId: 2036,
  },
  {
    countryCode: 'GB',
    location: 'United Kingdom',
    locationId: 2826,
  },
  {
    countryCode: 'DE',
    location: 'Germany',
    locationId: 2276,
  },
];
